module.exports = __webpack_public_path__ + "img/_3.9c873576.png";